<h2 mat-dialog-title>Wybierz miejsce odbioru karty</h2>

<mat-dialog-content>
  @if (loading) {
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (branches.length === 0) {
    <p class="no-data">Brak miejsc odbioru do wyświetlenia</p>
  } @else {
    <div class="branches-list">
      @for (branch of branches; track branch.id) {
        <div 
          class="branch-card"
          [class.selected]="selectedBranchId === branch.id"
          (click)="selectBranch(branch.id)">
          <div class="branch-name">{{ branch.name }}</div>
          @if (branch.description) {
            <div class="branch-description" [innerHTML]="formatDescription(branch.description)"></div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Anuluj</button>
  <button class="custom-button" (click)="confirm()" [disabled]="!selectedBranchId">
    Wybierz
  </button>
</mat-dialog-actions>
